<script>
  import MenuHeading from "./../../shared/MenuHeading.svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import { Wave } from "svelte-loading-spinners";
  import * as ls from "local-storage";
  import { onMount } from "svelte";
  import AddNewPhotos from "./AddNewPhotos.svelte";
  import loadData from "../../utils/loadData";

  export let styleID;

  let uploading = false;
  let loading = true;

  let name = null;
  let price = null;
  let inventoryLevel = null;
  let SKU = null;

  let photo2;
  let graphic2;

  onMount(() => {
    axios
      .get(`${$config.backendURL}/fstyles/${styleID}`)
      .then((res) => {
        name = res.data.name;
        price = res.data.price;
        inventoryLevel = res.data.inventoryLevel;
        SKU = res.data.SKU;

        photo2 = res.data.photo2;
        graphic2 = res.data.graphic2;

        loading = false;
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const handleClear = () => {
    name = null;
    price = null;
    inventoryLevel = null;
    SKU = null;
  };

  const handleSubmit = async (e) => {
    if (!name) alert("Product Name Missing");
    else if (!price) alert("Price missing!");
    else if (inventoryLevel == undefined) alert("Quantity missing!");
    else if (!SKU) alert("SKU missing!");
    else {
      uploading = true;

      let data = {
        name,
        price,
        inventoryLevel,
        SKU,
      };

      axios
        .put(`${$config.backendURL}/fstyles/${styleID}`, data, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          console.log(res.data);
          uploading = false;
          alert(`☑ Updated Successfully`);
          loadData();
        })
        .catch((err) => {
          alert("There was a problem, Refresh the page and retry");
          console.log(err);
          uploading = false;
        });
    }
  };
</script>

{#if !loading}
  <div class="">
    <!-- {#if !photo2 || !graphic2} -->
    <AddNewPhotos
      {styleID}
      hasPhoto={photo2 ? true : false}
      hasGraphic={graphic2 ? true : false}
    />
    <!-- {/if} -->

    <form
      on:submit|preventDefault={handleSubmit}
      class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
    >
      <div class="col-span-full -mt-10">
        <MenuHeading
          title="Edit Product of this Job Card"
          description="Fill out the form below to edit the item details."
        />
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Product Name :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={name}
            placeholder="Finished Product Name"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Price :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            step="any"
            bind:value={price}
            placeholder="Price"
          />
        </div>
      </div>

      <div class="grid grid-cols-2 gap-8">
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>Quantity :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="number"
            bind:value={inventoryLevel}
            placeholder="Quantity"
          />
        </div>
        <div class="grid grid-cols-3 gap-2 items-center">
          <div>SKU :</div>
          <input
            class="col-span-2 shadow-sm placeholder-gray-300"
            type="text"
            bind:value={SKU}
            placeholder="SKU"
          />
        </div>
      </div>

      {#if uploading}
        <div class="grid grid-cols-1 gap-8">
          <div class="flex items-center justify-center btn btn-primary-outline">
            <Wave size="25" color="rgb(244,162,97)" unit="px" />
            <span class="ml-4">Please wait...</span>
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="grid grid-cols-2 gap-8">
          <button class="btn btn-primary-outline" on:click={handleClear}>
            <i class="fas fa-times-circle mr-3" />
            Clear Form
          </button>
          <button class="btn btn-primary" on:click={handleSubmit}>
            <i class="fas fa-check-circle mr-3" />
            Save to Database
          </button>
        </div>
      {/if}
    </form>
  </div>
{/if}
